export { default as ModalDialog } from './ModalDialog';
export type { ModalDialogProps } from './ModalDialog';
